import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Tabs, Button, Modal } from "antd";
import StationDiagnostic from "./stationDiagnostic";
import EquDiagnostic from "./equDiagnostic";
import StationList from "./stationList";
import EquipmentList from "./equipmentList";
import DefaultBottom from "./defaultBottom";
import { STATION_MODULE, EQU_MODULE, DIA_TYPE } from "./config";
import "./index.styl";
// 图片引入
import selectBg from '../../../assets/img/diagnostic/select_bg.png';

const { TabPane } = Tabs;

class DiagnosticAnalysis extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      activeKey: "1",
      stationVisible: false,
      equVisible: false,
      selectInfo: {
        type: 0, // 选择的目标 0未选择 1电站 2设备
        info: null,
      },
    };
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentDidMount() {}

  tabChange = (key) => {
    this.setState({
      activeKey: key,
    });
  };

  // 设置选中信息
  setSelectInfo = (selectInfo) => {
    this.setState({
      selectInfo,
    });
  };

  // 电站选中

  render() {
    const { selectInfo } = this.state;

    const TabContent = (
      <Tabs activeKey={this.state.activeKey} onChange={this.tabChange}>
        <TabPane tab='设备诊断' key='1'>
          <div className='select-box'>
            <img alt="" src={selectBg} className='bg-container' />
            <Button type='primary' className='ant-btn-x' onClick={() => this.setState({ equVisible: true })}>
              选择设备
            </Button>
          </div>
          <DefaultBottom dataSource={EQU_MODULE} className='equ-default-bottom' />
        </TabPane>
        <TabPane tab='电站诊断' key='2'>
          <div className='select-box'>
            <img alt="" src={selectBg} className='bg-container' />
            <Button type='primary' className='ant-btn-x' onClick={() => this.setState({ stationVisible: true })}>
              选择电站
            </Button>
          </div>
          <DefaultBottom dataSource={STATION_MODULE} />
        </TabPane>
      </Tabs>
    );

    return (
      <div className='diagnostic-analysis-wrapper'>
        {selectInfo.type === 0 && TabContent}

        {selectInfo.type === 1 && (
          <EquDiagnostic
            {...this.props}
            diaType={DIA_TYPE}
            selectTarget={selectInfo.info}
            setSelectInfo={this.setSelectInfo}
            onSelect={() => this.setState({ equVisible: true })}
          />
        )}

        {selectInfo.type === 2 && (
          <StationDiagnostic
            {...this.props}
            diaType={DIA_TYPE}
            selectTarget={selectInfo.info}
            setSelectInfo={this.setSelectInfo}
            onSelect={() => this.setState({ stationVisible: true })}
          />
        )}

        <Modal
          title='选择电站'
          visible={this.state.stationVisible}
          footer={null}
          width={800}
          onCancel={() => this.setState({ stationVisible: false })}>
          <StationList
            onSelect={(info) => {
              this.setSelectInfo(info);
              this.setState({ stationVisible: false });
            }}
          />
        </Modal>
        <Modal
          className="choose-equipment-modal"
          title={<b style={{ fontSize: 18 }}>选择设备</b>}
          visible={this.state.equVisible}
          footer={null}
          width={800}
          onCancel={() => this.setState({ equVisible: false })}>
          <EquipmentList
            onSelect={(info) => {
              this.setSelectInfo(info);
              this.setState({ equVisible: false });
            }}
          />
        </Modal>
      </div>
    );
  }
}

export default DiagnosticAnalysis;



// WEBPACK FOOTER //
// ./src/AntD/pages/diagnosticManage/diagnosticAnalysis/index.js